import React,{Component} from 'react';
import styles from "./index.less";

interface Props{
    fixedTitle:string
}

class FixedTitle extends Component<Props>{
    constructor(props:Props){
        super(props);
    }

    render(){
        const {fixedTitle} = this.props;
        return (
            <div className={styles.fixedTitle}>
                <span>{fixedTitle}</span>
            </div>
        )
    }
}

export default  FixedTitle;